// LemmaParseHeadUtils.js (updated with support for lemma_chs expanded details)
import React, { useState } from 'react';
import { SpeakTextButton,LemmaAudioPlayer } from './LemmaPlayUtils';
import './LemmaParseHeadUtilstyle.css';

const LemmaDisplay = ({ lemmashead, lemmachs = '[]',headword, showlemma, langcodename}) => {
  const [tempShow, setTempShow] = useState(false);
  const [showMore, setShowMore] = useState(false);

  if (!lemmashead) return null;

  const parse_head = (lemmasHead) => {
    let parsedHead = [];
    try {
      parsedHead = JSON.parse(lemmasHead);
    } catch (error) {
      console.error("Error parsing lemmasHead:", error);
      return <div>Invalid lemmashead format.</div>;
    }

    if (!Array.isArray(parsedHead)) {
      return <div>No lemma lemmashead available.</div>;
    }

    return parsedHead.map(({subject_pos, definition2, definition2_chs }, index) => (
      <div key={index} className="mb-2">
        <div><strong>{index + 1}:</strong> {subject_pos}</div>
        <div class="en-def"><strong></strong> {definition2.value}

          <LemmaAudioPlayer aidurl={definition2.aid} aidtext={definition2.value} />
        </div>
        <div class="chs-def"><strong></strong> {definition2_chs.value}

          <LemmaAudioPlayer aidurl={definition2_chs.aid} aidtext={definition2_chs.value} />
        </div>
      </div>
    ));
  };

  const parseExamples = (examples = []) => {
    if (!Array.isArray(examples) || examples.length === 0) return null;
  
    return (
      <div className="ld-examples">
        <strong>Examples:</strong>
        <ul>
          {examples.map((example, idx) => (
            <li key={idx}>
              {example}
              <SpeakTextButton headword={example} />
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const parseHeadwordExamples = (examples = [], headword = '') => {
    if (!Array.isArray(examples) || examples.length === 0 || !headword) return null;
  
    const lowerHeadword = headword.toLowerCase();
  
    // Filter examples containing the headword (case-insensitive)
    const filtered = examples.filter(example =>
      example.toLowerCase().includes(lowerHeadword)
    );
  
    if (filtered.length === 0) return null;
  
    return (
      <div className="ld-examples">
        <strong>Examples:</strong>
        <ul>
          {filtered.map((example, idx) => (
            <li key={idx}>
              {example}
              <SpeakTextButton headword={example} />
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const parseHeadwordExamplesWithChs = (examples_def = [], examples_def_chs = [], headword = '') => {
    if (!Array.isArray(examples_def) || examples_def.length === 0 || !headword) return null;
  
    const lowerHeadword = headword.toLowerCase();
  
    // Find matched indexes
    const matchedIndexes = examples_def
      .map((example, idx) => example.value.toLowerCase().includes(lowerHeadword) ? idx : -1)
      .filter(idx => idx !== -1);
  
    if (matchedIndexes.length === 0) return null;
  
    return (
      <div className="ld-examples">
        {/* <strong>Examples:</strong> */}
         <strong></strong>
        <ul>
          {matchedIndexes.map((idx) => (
            <li key={idx}>
              {/* English example */}
              {examples_def[idx].value}
              <LemmaAudioPlayer aidurl={examples_def[idx].aid} aidtext={examples_def[idx].value} />
              {/* Mandarin example if exists */}
              {examples_def_chs[idx] && (
                <>
                  <div style={{ marginTop: '4px', color: '#666' }}>
                    {examples_def_chs[idx].value}
                    <LemmaAudioPlayer aidurl={examples_def_chs[idx].aid} aidtext={examples_def_chs[idx].value} />
                  </div>
                </>
              )}
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const parse_lemma_chs = (lemmaChsData) => {
    let parsed = [];
    try {
      parsed = JSON.parse(lemmaChsData);
    } catch (error) {
      console.error("Error parsing lemma_chs:", error);
      return <div>Invalid more lemma data.</div>;
    }

    if (!Array.isArray(parsed)) {
      return <div>No additional lemma data.</div>;
    }

    parsed.sort((a, b) => {
      const aSub = (a.subject || '').split('.')[0];
      const bSub = (b.subject || '').split('.')[0];
      return aSub.localeCompare(bSub);
    });

    return parsed.map((item, index) => (
      <div key={`chs-${index}`} className="ld-expanded-block">
        <div><strong>{index + 1}:</strong> {(item.subject || '').split('.')[0]}</div>
        <div class="en-def"><strong></strong> {item.definition}
          <LemmaAudioPlayer aidurl={item.definition2.aid} aidtext={item.definition2.value} />
        </div>
        <div class="chs-def"><strong></strong> {item.definition_chs}
          <LemmaAudioPlayer aidurl={item.definition2_chs.aid} aidtext={item.definition2_chs.value} />
        </div>
        {parseHeadwordExamplesWithChs(item.examples_def,item.examples_def_chs,headword)}
      </div>
    ));
  };

  return (
<div className="spStoreAddress">
  {(showlemma === 1 || tempShow) ? (
    <>
      {parse_head(lemmashead)}
      
      {/* --- THIS IS THE NEW UNIFIED BUTTON --- */}
      <button 
        className={`ld-show-more-btn ${showMore ? 'expanded' : ''}`} 
        onClick={() => setShowMore(!showMore)}
      >
        <span>{showMore ? 'Show less' : 'Show more'}</span>
        <i className="chevron"></i>
      </button>

      {/* This part remains the same: it only shows when showMore is true */}
      {showMore && parse_lemma_chs(lemmachs)}
    </>
  ) : (
    // We can style this initial "click to show" prompt to be consistent too
    <div className="blurred-lemma" onClick={() => setTempShow(true)}>
      Enable lemma
    </div>
  )}
</div>
  );
};

export default LemmaDisplay;
